import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconSort = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='m7 15 5 5 5-5' />
      <path d='m7 9 5-5 5 5' />
    </g>
  </SDIcon>
)

export default IconSort
